import { MainPagesNavbar } from "./MainPagesNavbar";
import { MainPageFooter } from "./MainPageFooter";

export const SiteLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="mainPage">
      <MainPagesNavbar />
      <main className="l-pageContent u-bgPrimaryLightest" style={{ paddingTop: 100 }}>
        {children}
        <MainPageFooter />
      </main>
    </div>
  );
};
